const ZoneRestricted = [
  '51', '52',  //Ceuta melilla
  '35', '38', // canarias
];
const ShippingMessages = {
  'zone': [
    { type: 'zoneRestricted', message: 'Lo sentimos pero el envío a tu localidad no está disponible' }
  ]
};

export namespace ShippingHelper {

  //indica si la soza está permitida
  export const isRestricted = (postalCode: string, unrestrictedZones = []) => {
    const cp = postalCode ? postalCode.substr(0, 2) : '00';
    return ZoneRestricted.includes(cp) && !unrestrictedZones.includes(cp);
  };

  //devuelve un mensaje
  export const getPropertymessages = (property) => {
    return ShippingMessages[property];
  };


}
